(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Media Carousel Section Functionality
    /*****************************************************/

    // Initialize Hero Carousel for Mobile (support multiple instances)
    if ($(".media-carousel-section .hero-carousel").length) {
      // Function to stop videos within a given scope (section or entire document)

      function stopAllHeroVideos($scope) {
        var $root = $scope && $scope.length ? $scope : $(document);

        // Stop native videos
        $root.find(".hero-video").each(function () {
          this.pause();
          this.currentTime = 0;
          this.load(); // Reload to show poster
          $(this).closest(".image-contain").find(".play-button").removeClass("playing");
        });

        // Stop external videos (YouTube/Vimeo)
        $root.find(".external-video-iframe.active").each(function () {
          var $iframe = $(this);
          var $container = $iframe.closest(".image-contain");

          // Hide iframe and show thumbnail
          $iframe.removeClass("active").hide();
          $container.find(".video-thumbnail").show();
          $container.find(".play-button").removeClass("playing");

          // Reset iframe src to stop video
          $iframe.attr("src", "");
        });
      }

      // Initialize/destroy each carousel instance based on viewport
      function initializeHeroCarousels() {
        var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

        $(".media-carousel-section .hero-carousel").each(function () {
          var $carousel = $(this);
          var $section = $carousel.closest(".media-carousel-section");

          if (isMobile && !$carousel.hasClass("owl-carousel-initialized")) {
            $carousel.addClass("owl-carousel-initialized").owlCarousel({
              items: 1,
              loop: false,
              margin: 20,
              stagePadding: 40,
              dots: true,
              nav: false,
              autoplay: false,
              center: false,
              responsive: {
                0: { stagePadding: 32 },
                768: { stagePadding: 40 },
              },
            });

            // Handle slide change - stop videos within this section
            $carousel.on("changed.owl.carousel", function () {
              stopAllHeroVideos($section);
            });
          } else if (!isMobile && $carousel.hasClass("owl-carousel-initialized")) {
            // Destroy carousel on desktop for this instance only
            $carousel.trigger("destroy.owl.carousel").removeClass("owl-carousel-initialized");
            stopAllHeroVideos($section);
          }
        });
      }

      // Initialize on load
      initializeHeroCarousels();

      // Auto-play first video on page load
      function autoplayFirstVideo() {
        var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

        if (!isMobile) {
          $(".media-carousel-section").each(function () {
            var $section = $(this);
            var $firstVideoContainer = $section.find(".image-contain.has-video").first();

            if ($firstVideoContainer.length) {
              var $playButton = $firstVideoContainer.find(".play-button");

              // Small delay to ensure everything is loaded
              setTimeout(function () {
                $playButton.trigger("click");
              }, 500);
            }
          });
        }
      }

      // Call autoplay after initialization
      autoplayFirstVideo();

      // Re-initialize on window resize
      $(window).on("resize", function () {
        setTimeout(initializeHeroCarousels, 100);
      });
    }

    // Video Play Button Click Handler (Native and External)
    $(document).on("click", ".media-carousel-section .play-button", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest(".image-contain");
      var $section = $button.closest(".media-carousel-section");
      var $video = $container.find(".hero-video")[0];
      var $externalContainer = $container.find(".external-video-container");
      var $iframe = $container.find(".external-video-iframe");

      // Handle external videos (YouTube/Vimeo)
      if ($externalContainer.length && $iframe.length) {
        var embedSrc = $iframe.attr("data-src");
        var isPlaying = $iframe.hasClass("active");

        if (!isPlaying) {
          // Stop all other videos first
          stopAllHeroVideos();

          // Show iframe and hide thumbnail
          $iframe
            .attr("src", embedSrc + (embedSrc.indexOf("?") === -1 ? "?autoplay=1" : "&autoplay=1"))
            .addClass("active")
            .show();
          $container.find(".video-thumbnail").hide();
          $button.addClass("playing");
        } else {
          // Stop external video
          $iframe.removeClass("active").hide().attr("src", "");
          $container.find(".video-thumbnail").show();
          $button.removeClass("playing");
        }
      }
      // Handle native videos
      else if ($video) {
        if ($video.paused) {
          // Stop all other videos first
          stopAllHeroVideos();

          // Play this video
          $video
            .play()
            .then(function () {
              $button.addClass("playing");
            })
            .catch(function (error) {
              console.log("Video play failed:", error);
            });
        } else {
          // Pause video and reset to show poster
          $video.pause();
          $video.currentTime = 0;
          $video.load(); // Reload to show poster
          $button.removeClass("playing");
        }
      }
    });

    // Native Video Click Handler (toggle play/pause)
    $(document).on("click", ".media-carousel-section .hero-video", function (e) {
      var $video = this;
      var $button = $(this).closest(".image-contain").find(".play-button");

      if ($video.paused) {
        // Stop all other videos first
        stopAllHeroVideos();

        // Play this video
        $video
          .play()
          .then(function () {
            $button.addClass("playing");
          })
          .catch(function (error) {
            console.log("Video play failed:", error);
          });
      } else {
        // Pause video and reset to show poster
        $video.pause();
        $video.currentTime = 0;
        $video.load(); // Reload to show poster
        $button.removeClass("playing");
      }
    });

    // External Video Thumbnail Click Handler
    $(document).on("click", ".media-carousel-section .video-thumbnail", function (e) {
      e.preventDefault();
      var $thumbnail = $(this);
      var $container = $thumbnail.closest(".image-contain");
      var $button = $container.find(".play-button");

      // Trigger the play button click
      $button.trigger("click");
    });

    // Native Video ended event
    $(document).on("ended", ".media-carousel-section .hero-video", function () {
      var $button = $(this).closest(".image-contain").find(".play-button");
      $button.removeClass("playing");
      this.currentTime = 0;
      this.load(); // Reload to show poster
    });

    // Handle external video iframe load events (for better UX)
    $(document).on("load", ".media-carousel-section .external-video-iframe", function () {
      // Optional: You could add loading states or other enhancements here
    });
  });
})(jQuery);
